.icon {
  width: 40px;
  height: 40px;
  background: var(--paletteWhite2);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
